import { useEffect } from 'react'
import useFetchPipeline from '../../hooks/useFetchPipeline'
import useGlobalState from '../../hooks/useGlobalState'
import PageSwitch from './PageSwitch'
import PageSelectize from './PageSelectize'
import { LoadingIndicator } from '../LoadingIndicator'

const componentsBySchema = {
    switch: PageSwitch,
    selectize: PageSelectize,
}

function InvalidDataUrl() {
    return (
        <>
            <b>Data URL is missing or invalid</b>
            <p>
                This is expected behavior when the redbox-URL is called directly
            </p>
        </>
    )
}

function InvalidData() {
    return (
        <div className="rounded px-6 py-8 text-center shadow-[0_1px_4px_0_#32323280]">
            <p data-testid="graph-inactive">
                This graph is currently not available, but will be back shortly.
            </p>
        </div>
    )
}

export default function Template() {
    const dataUrl = useGlobalState((state) => state.dataUrl)
    const setState = useGlobalState((state) => state.setState)
    const setDataVersion = (dataVersion: string) => setState({ dataVersion })

    const result = useFetchPipeline(dataUrl)

    const dataVersion = result.value?.meta?.version
    useEffect(() => {
        setDataVersion(dataVersion)
    }, [dataVersion])

    if (!dataUrl) {
        return <InvalidDataUrl />
    }

    if (result.loading) {
        return <LoadingIndicator loading />
    }

    if (result.error) {
        return <InvalidData />
    }

    const schema = result.value?.meta?.schema as
        'switch' | 'selectize' | undefined
    const Component = (schema && componentsBySchema[schema]) || InvalidData
    return <Component data={result.value} />
}
